import React, { FC } from "react";

import { typedTimeProblem } from "../../features/time/editTime.utils";

type Props = {
  value: { h: string; m: string };
  onChange: (value: { h: string; m: string }) => void;
  inputClassName?: string;
  /** Called with a message when a typed key is refused ("" when the value is fine). */
  onProblem?: (message: string) => void;
};

const InputTime: FC<Props> = ({
  value,
  onChange,
  inputClassName,
  onProblem,
}) => {
  const handleHourChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newHour = e.target.value;
    if (/^\d*$/.test(newHour)) {
      // Allow only numbers
      onProblem?.("");
      onChange({ ...value, h: newHour });
    } else {
      onProblem?.(typedTimeProblem("h", newHour));
    }
  };

  const handleMinuteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMinute = e.target.value;
    if (
      /^\d*$/.test(newMinute) &&
      (newMinute === "" || parseInt(newMinute, 10) < 60)
    ) {
      // Allow only numbers and less than 60
      onProblem?.("");
      onChange({ ...value, m: newMinute });
    } else {
      onProblem?.(typedTimeProblem("m", newMinute));
    }
  };

  return (
    <div className={"flex items-center gap-4"}>
      <div className={"flex items-center gap-2"}>
        <input
          className={`input input-bordered w-16 ${inputClassName || ""}`}
          type={"text"}
          value={value.h}
          onChange={handleHourChange}
          onFocus={(e) => e.target.select()}
        />
        <div className={"text-sm"}>hr</div>
      </div>
      <div className={"flex items-center gap-2"}>
        <input
          className={`input input-bordered w-16 ${inputClassName || ""}`}
          type={"text"}
          value={value.m}
          onChange={handleMinuteChange}
          maxLength={2}
          onFocus={(e) => e.target.select()}
        />
        <div className={"text-sm"}>min</div>
      </div>
    </div>
  );
};

export default InputTime;
